import type { TerminalKind } from '@crm/contracts';
import { stageTone, TONE_VARIANT } from '../../lib/value-tones.ts';
import { Badge } from './badge.tsx';

/** A stage in a list column: a pill coloured by its outcome (open yellow, won green, lost red). */
export function StagePill({
  name,
  terminalKind,
}: {
  name: string;
  terminalKind: TerminalKind | null | undefined;
}) {
  return (
    <Badge variant={TONE_VARIANT[stageTone(terminalKind)]} title={name} data-stage-pill="">
      {name}
    </Badge>
  );
}
